if(window.customer != undefined){ 
  var customerID = JSON.stringify(window.customer.id);
  var customerEmail = window.customer.email;
  var customerFirstName = JSON.stringify(window.customer.firstName);
  var customerLastName = JSON.stringify(window.customer.lastName);
  var customerPhone = JSON.stringify(window.customer.phone);
  var customerDefaultAddress = JSON.stringify(window.customer.defaultAddress);
  let customerData = {
      customerID: customerID,
      customerEmail: customerEmail,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      customerPhone: customerPhone,
      customerDefaultAddress: customerDefaultAddress,
  };


  // On checkout page get cart data
  // $(document).on("click", "#checkout_btn", function (e) {
  //   e.preventDefault();
  //   // Check cart is empty or has any product
  //   $.ajax({
  //     type: "GET",
  //     url: "/cart.js",
  //     dataType: "json",
  //     success: function (cart) {
  //       if (cart.item_count > 0) {
  //         // console.log('The cart is not empty');

  //         jQuery.getJSON("/cart.js", function (cartdata) {
  //           var cData = {
  //             cartData: cartdata,
  //             customerData: customerData,
  //           };

  //           // alert(cartdata);
  //           let utf8EncodedString = encodeURIComponent(JSON.stringify(cData));
  //           let base64EncodedString = btoa(utf8EncodedString);

  //           let form = document.createElement("form");
  //           form.method = "POST";
  //           form.action = "http://server.richyhair.se/";
    
  //           // Create a hidden input for the data
  //           let input = document.createElement("input");
  //           input.type = "hidden";
  //           input.name = "cartData"; // Server will read this from req.body.cartData
  //           input.value = base64EncodedString;
    
  //           // Append and submit the form
  //           form.appendChild(input);
  //           document.body.appendChild(form);
  //           form.submit();
            
  //           // document.location.href =
  //           //   "http://server.richyhair.se/?cartData=" +
  //           //   base64EncodedString;

  //           // document.location.href =
  //           //   "http://server.richyhair.se/richyhairdanishCustom/?cartData=" +
  //           //   base64EncodedString;

            
  //         });
  //       } else {
  //         console.log("The cart is empty");
  //       }
  //     },
  //   });
  // });
}